<template>
  <div class="history-container">
    <div class="page-content">
      <div class="operation-bar">
        <el-button
          type="danger"
          v-if="getAllMenuCodes.includes('RGix4RvQ')"
          size="mini"
          @click="handleBatchDelete"
          :disabled="!selectedRows.length"
          >删除</el-button
        >
        <div class="search-box">
          <span style="margin: 0 6px; color: #fff">大棚编号</span>
          <el-select
            v-model="greenhouseId"
            placeholder="请选择"
            style="width: 160px"
            size="mini"
            clearable
          >
            <el-option
              v-for="item in searchOptions.greenhouseOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>

          <span style="margin: 0 6px; color: #fff">执行人</span>
          <el-select
            v-model="executorId"
            placeholder="请选择"
            style="width: 160px"
            size="mini"
            clearable
          >
            <el-option
              v-for="item in executorOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>

          <span style="margin: 0 6px; color: #fff">状态</span>
          <el-select
            v-model="execStatus"
            placeholder="请选择"
            style="width: 140px"
            size="mini"
            clearable
          >
            <el-option label="待执行" value="WAITING"></el-option>
            <el-option label="已完成" value="COMPLETED"></el-option>
            <el-option label="已延期" value="DELAYED"></el-option>
          </el-select>

          <el-button
            icon="el-icon-search"
            style="margin-left: 10px"
            size="mini"
            type="primary"
            @click="handleSearch"
            >查询</el-button
          >
          <el-button
            type="success"
            size="mini"
            @click="handleExport"
            :loading="exportLoading"
            style="margin-left: 8px"
            >导出</el-button
          >
        </div>
      </div>

      <el-table
        :data="tableData"
        border
        height="50vh"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          label="序号"
          type="index"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="greenhouseName"
          label="大棚编号"
        ></el-table-column>
        <el-table-column label="任务分类">
          <template slot-scope="scope">
            {{ scope.row.categoryName || scope.row.taskCategoryName || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="农事动作">
          <template slot-scope="scope">
            {{ scope.row.actions || scope.row.taskActions || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="重点防治病虫害">
          <template slot-scope="scope">
            {{ scope.row.pestControl || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="温湿度要求">
          <template slot-scope="scope">
            {{ scope.row.stdHumidityTemp || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="执行时间" width="180">
          <template slot-scope="scope">
            {{
              formatDateRange(
                scope.row.execStartDate || scope.row.startDate,
                scope.row.execEndDate || scope.row.endDate
              )
            }}
          </template>
        </el-table-column>
        <el-table-column label="执行人">
          <template slot-scope="scope">
            {{
              scope.row.executorNickName ||
              scope.row.executorName ||
              scope.row.executorUsername ||
              "-"
            }}
          </template>
        </el-table-column>
        <el-table-column label="注意事项">
          <template slot-scope="scope">
            {{ scope.row.precautions || scope.row.notes || "-" }}
          </template>
        </el-table-column>

        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.execStatus)" size="mini">
              {{ getStatusText(scope.row.execStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="180">
          <template slot-scope="scope">
            {{ formatTime(scope.row.updateTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="
                (scope.row.execStatus === 'WAITING' ||
                  scope.row.execStatus === 'DELAYED') &&
                getAllMenuCodes.includes('h4ePg8YV')
              "
              type="text"
              style="color: #409eff"
              @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              v-if="
                scope.row.execStatus !== 'COMPLETED' &&
                scope.row.canExec &&
                getAllMenuCodes.includes('fCxBreY1')
              "
              type="text"
              style="color: #2680dd"
              @click="handleExecute(scope.row)"
              >执行</el-button
            >
            <el-button
              type="text"
              style="color: #04ff9f"
              @click="handleView(scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 任务执行弹窗 -->
    <TaskExecutionDialog
      :visible.sync="viewDialogVisible"
      :taskData="selectedTask"
      :mode="dialogMode"
      @success="handleTaskSuccess"
    />

    <!-- 编辑弹窗 -->
    <TaskEditDialog
      :visible.sync="editDialogVisible"
      :taskData="editData"
      :greenhouse-options="greenhouseOptions"
      :variety-options="varietyOptions"
      :task-category-options="taskCategoryOptions"
      :executor-cascader-options="executorOptions"
      @success="handleEditDialogSuccess"
    />
  </div>
</template>

<script>
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";
import TaskExecutionDialog from "./TaskExecutionDialog.vue";
import TaskEditDialog from "./TaskEditDialog.vue";
import { mapGetters } from "vuex";
import dayjs from "dayjs";

export default {
  name: "History",
  components: {
    TaskExecutionDialog,
    TaskEditDialog,
  },
  data() {
    return {
      greenhouseId: "",
      varietyId: "",
      cycleDetailId: "",
      categoryId: "",
      executorId: "",
      execStatus: "",
      queryDate: "",
      selectedRows: [],
      tableData: [],
      page: 1,
      pageSize: 10,
      totalCount: 0,
      viewDialogVisible: false,
      selectedTask: {},
      greenhouseOptions: [],
      varietyOptions: [],
      growthStageOptions: [],
      executorOptions: [],
      searchOptions: {
        greenhouseOptions: [],
        varietyOptions: [],
        categoryOptions: [],
      },
      dialogMode: "execute", // 新增：用于区分执行和查看模式
      exportLoading: false,
      // 编辑相关状态
      editDialogVisible: false,
      editData: {},
      greenhouseOptions: [],
      varietyOptions: [],
      taskCategoryOptions: [],
      executorOptions: [],
    };
  },

  created() {
    this.fetchData();
    this.fetchOptions();
    this.fetchSearchOptions();
    this.fetchGreenhouseOptions();
    this.fetchVarietyOptions();
    this.fetchTaskCategoryOptions();
    this.fetchExecutorOptions();
  },
  computed: {
    ...mapGetters("user", ["getAllMenuCodes"]),
  },
  methods: {
    // 获取搜索下拉
    async fetchSearchOptions() {
      this.searchOptions.varietyOptions = this.$store.state.farm.varietyOptions;
      this.searchOptions.greenhouseOptions =
        this.$store.state.farm.greenhouseOptions;
      const res = await axios.get(
        baseUrl + "/api/farming/task-config/selectionV2"
      );
      if (res.code === 200) {
        this.searchOptions.categoryOptions = res.data.map((item) => ({
          label: item.categoryName,
          value: item.categoryId,
        }));
      }
    },
    async fetchData() {
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          greenhouseId: this.greenhouseId || undefined,
          executorId: this.executorId || undefined,
          execStatus: this.execStatus || undefined,
        };

        const res = await axios.post(
          baseUrl + "/api/digital-farming/task/allot-record/list-page",
          params
        );
        if (res.code === 200) {
          this.tableData = res.data.list || [];
          this.totalCount = parseInt(res.data.totalCount) || 0;
        }
        console.log("查询参数:", params);
      } catch (error) {
        console.error("获取数据失败:", error);
        this.$message.error("获取数据失败");
      }
    },
    async fetchOptions() {
      try {
        // 获取大棚选项
        const greenhouseRes = await axios.get(
          baseUrl + "/api/digital-farming/growth-cycle/selection-greenhouse"
        );
        if (greenhouseRes.code === 200) {
          this.greenhouseOptions = greenhouseRes.data.map((item) => ({
            label: item.name,
            value: item.id,
          }));
        }

        // 获取草莓品种选项
        const varietyRes = await axios.post(
          baseUrl + "/api/digital-farming/growth-cycle/list-all",
          {
            enabled: 1,
          }
        );
        if (varietyRes.code === 200) {
          console.log("caomianxiang", varietyRes.data);

          this.varietyOptions = varietyRes.data.map((item) => ({
            label: item.varietyName,
            value: item.id,
            details: item.details,
          }));
        }

        // 获取生长时期选项
        this.growthStageOptions = this.$store.state.farm.stageOptions;
      } catch (error) {
        console.error("获取选项失败:", error);
      }
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleSearch() {
      this.page = 1;
      this.fetchData();
    },

    async handleBatchDelete() {
      if (!this.selectedRows.length) return;
      try {
        await this.$confirm(
          `确认删除选中的 ${this.selectedRows.length} 个任务记录吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );
        const ids = this.selectedRows.map((row) => row.id);
        const res = await axios.post(
          baseUrl + "/api/digital-farming/task/allot-record/delete-batch",
          ids
        );
        if (res.code === 200) {
          this.fetchData();
        }
        console.log("删除任务:", ids);
      } catch (error) {
        if (error !== "cancel") {
          console.error("删除失败:", error);
        }
      }
    },
    async handleEdit(row) {
      try {
        // 调用详情接口获取完整数据
        const res = await axios.post(
          baseUrl +
            `/api/digital-farming/task/allot-record/detail-by-id/${row.id}`
        );
        if (res.code === 200) {
          // 先设置数据，再显示弹窗，避免 watcher 触发问题
          this.editData = {
            ...res.data,
            details: res.data.details || [],
          };
          console.log(res);

          // 使用 nextTick 确保数据更新完成后再显示弹窗
          this.$nextTick(() => {
            this.editDialogVisible = true;
          });
        } else {
          this.$message.error(res.message || "获取详情失败");
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        this.$message.error("获取详情失败");
      }
    },
    handleExecute(row) {
      console.log("执行任务:", row);
      this.selectedTask = { ...row };
      this.dialogMode = "execute"; // 设置为执行模式
      this.viewDialogVisible = true;
      console.log("设置后的 selectedTask:", this.selectedTask);
      console.log("设置后的 viewDialogVisible:", this.viewDialogVisible);
    },
    handleView(row) {
      console.log("查看任务:", row);
      this.selectedTask = { ...row };
      this.dialogMode = "view"; // 设置为查看模式
      this.viewDialogVisible = true;
      console.log("设置后的 selectedTask:", this.selectedTask);
      console.log("设置后的 viewDialogVisible:", this.viewDialogVisible);
    },
    handleTaskSuccess() {
      this.fetchData();
    },
    // 编辑弹窗成功回调
    handleEditDialogSuccess() {
      this.fetchData();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
    getStatusType(status) {
      const statusMap = {
        WAITING: "warning",
        COMPLETED: "success",
        DELAYED: "danger",
      };
      return statusMap[status] || "info";
    },
    getStatusText(status) {
      const statusMap = {
        WAITING: "待执行",
        COMPLETED: "已完成",
        DELAYED: "已延期",
      };
      return statusMap[status] || status;
    },
    formatTime(time) {
      if (!time) return "";
      const date = new Date(time);
      return date
        .toLocaleString("zh-CN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
        .replace(/\//g, "/");
    },
    formatDateRange(startDate, endDate) {
      if (!startDate || !endDate) return "";
      const start = new Date(startDate);
      const end = new Date(endDate);
      const formatDate = (date) => {
        return date.toLocaleDateString("zh-CN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      };
      return `${formatDate(start)} `;
    },
    // 获取当前温湿度数据
    getCurrentTempHumidity() {
      // 模拟获取温湿度数据
      this.deviceStatusData = this.deviceStatusData.map((device) => ({
        ...device,
        temperature: Math.floor(Math.random() * 10 + 20) + "°C",
        humidity: Math.floor(Math.random() * 20 + 60) + "%",
        updateTime: new Date().toLocaleString("zh-CN"),
      }));
      this.$message.success("已获取当前温湿度数据");
    },
    // 导出数据
    async handleExport() {
      this.exportLoading = true;
      try {
        // 构建导出参数，与分页接口参数一致
        const exportParams = {
          page: this.page,
          pageSize: this.pageSize,
          greenhouseId: this.greenhouseId || undefined,
          varietyId: this.varietyId || undefined,
          cycleDetailId: this.cycleDetailId || undefined,
          categoryId: this.categoryId || undefined,
          executorId: this.executorId || undefined,
          execStatus: this.execStatus || undefined,
          queryDate: this.queryDate || undefined,
        };

        const response = await axios.post(
          baseUrl + "/api/digital-farming/task/allot-record/export",
          exportParams,
          {
            responseType: "blob",
          }
        );

        // 处理文件流下载
        // 如果响应已经是Blob，直接使用；否则创建新的Blob
        let blob;
        if (response instanceof Blob) {
          blob = response;
        } else if (response.data instanceof Blob) {
          blob = response.data;
        } else {
          blob = new Blob([response.data || response], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
        }

        // 创建下载链接
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.style.display = "none";

        // 生成文件名
        const fileName = `农事任务记录_${dayjs().format(
          "YYYYMMDDHHmmss"
        )}.xlsx`;
        link.setAttribute("download", fileName);

        // 触发下载
        document.body.appendChild(link);
        link.click();

        // 清理
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);

        this.$message.success("导出成功");
      } catch (error) {
        console.error("导出失败:", error);
        // 如果错误是Blob对象，说明可能是接口返回了错误信息
        if (error instanceof Blob) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorMsg = JSON.parse(reader.result);
              this.$message.error(errorMsg.message || "导出失败");
            } catch (e) {
              this.$message.error("导出失败，请稍后重试");
            }
          };
          reader.readAsText(error);
        } else {
          this.$message.error(error.message || "导出失败，请稍后重试");
        }
      } finally {
        this.exportLoading = false;
      }
    },
    // 获取大棚选项
    async fetchGreenhouseOptions() {
      try {
        const res = await axios.get(
          baseUrl + "/api/digital-farming/growth-cycle/selection-greenhouse",
          {
            enabled: 1,
          }
        );
        if (res.code === 200) {
          this.greenhouseOptions = res.data.map((item) => ({
            label: item.name,
            value: item.id,
          }));
        }
      } catch (error) {
        console.error("获取大棚选项失败:", error);
      }
    },
    // 获取草莓品种选项
    async fetchVarietyOptions() {
      try {
        const res = await axios.post(
          baseUrl + "/api/digital-farming/growth-cycle/list-all",
          {
            enabled: 1,
          }
        );
        if (res.code === 200) {
          this.varietyOptions = res.data.map((item) => ({
            label: item.varietyName,
            value: item.id,
            details: item.details,
          }));
        }
      } catch (error) {
        console.error("获取品种选项失败:", error);
      }
    },
    // 获取任务分类选项
    async fetchTaskCategoryOptions() {
      try {
        const res = await axios.get(
          baseUrl + "/api/farming/task-config/selectionV2"
        );
        if (res.code === 200) {
          console.log(res.data);

          this.taskCategoryOptions = res.data
            .filter((item) => item.inner !== 1)
            .map((item) => ({
              label: item.categoryName,
              categoryId: item.categoryId,
              categoryActionsList: item.categoryActionsList,
            }));
        }
      } catch (error) {
        console.error("获取任务分类选项失败:", error);
      }
    },
    // 获取执行人选项
    async fetchExecutorOptions() {
      try {
        const res = await axios.post(baseUrl + "/api/system/users");
        if (res.code === 200) {
          // 过滤出角色为农技员的用户
          const agriTechUsers = res.data.filter(
            (user) =>
              user.roleCodes &&
              user.roleCodes.split(",").includes("greenhouse_admin")
          );

          // 构建选择器数据
          this.executorOptions = agriTechUsers.map((item) => ({
            id: item.id,
            name: `${item.nickName || item.realName || ""} (${item.username})`,
            username: item.username,
            nickName: item.nickName || item.realName,
          }));
          console.log("执行人选项", this.executorOptions);
        } else {
          console.error("获取用户列表失败:", res.message);
        }
      } catch (error) {
        console.error("获取执行人选项失败:", error);
        this.$message.error("获取执行人列表失败");
      }
    },
    // 提交执行结果
    async handleSubmitExecution() {
      try {
        // 验证必填项
        if (
          this.executionForm.pestControl === "有病虫害" &&
          !this.executionForm.pestDescription
        ) {
          this.$message.error("请填写病虫害描述");
          return;
        }
        if (
          this.executionForm.tempHumidityControl === "不合格" &&
          !this.executionForm.tempHumidityDescription
        ) {
          this.$message.error("请填写温湿度异常情况描述");
          return;
        }

        // 构建提交数据
        const submitData = {
          id: this.viewRow.id,
          completed: this.executionForm.actionCompleted === "完成" ? 1 : 0,
          pestsDiseasesResult:
            this.executionForm.pestControl === "有病虫害" ? 1 : 0,
          pestsDiseasesDesc: this.executionForm.pestDescription,
          pestsDiseasesImgs: this.executionForm.pestImages,
          tempHumidityResult:
            this.executionForm.tempHumidityControl === "合格" ? 1 : 0,
          tempHumidityDesc: this.executionForm.tempHumidityDescription,
          tempHumidityImgs: this.executionForm.tempHumidityImages,
          otherSituations: this.executionForm.otherFeedback,
          realExecTime: new Date().toISOString(),
        };

        // 调用API提交执行结果
        const res = await axios.put(
          baseUrl + `/api/digital-farming/task/allot-record/exec`,
          submitData
        );
        if (res.code === 200) {
          this.$message.success("任务执行成功");
          this.viewDialogVisible = false;
          this.fetchData();
        } else {
        }
      } catch (error) {
        console.error("执行失败:", error);
      }
    },
  },
};
</script>

<style scoped lang="less">
.history-container {
  width: calc(100vw - 20px);

  .page-content {
    box-sizing: border-box;
    background: rgba(0, 11, 47, 0.3);
    padding: 20px;
    border-radius: 4px;
    width: 100%;

    .operation-bar {
      margin-bottom: 20px;
      display: flex;
      align-items: center;

      .search-box {
        margin-left: auto;
        display: flex;
        align-items: center;
      }
    }

    .pagination-container {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>
